import React from "react"
import SingleImage from "./singleImage"
import DoubleImage from "./doubleImage"
import styles from "./ImageGallery.module.scss"

const ImageGallery = ({ node }) => {
  return (
    <div className={styles.galleryWrapper}>
      {node.images.map((item, index) =>
        item._type === "galleryImage" ? (
          <SingleImage
            key={`image-${index}`}
            image={item.image}
            caption={item.caption}
            alt={item.alt}
          />
        ) : (
          <DoubleImage
            key={`image-${index}`}
            leftImage={item.leftImage}
            rightImage={item.rightImage}
          />
        )
      )}
    </div>
  )
}

export default ImageGallery
